var render = function render(){var _vm=this,_c=_vm._self._c;return _c('info-screen',{staticClass:"startRegistration",attrs:{"title":_vm.$ml.get('setPinCodeTitleReg'),"text":_vm.$ml.get('setPinCodeTextReg'),"action":_vm.nextScreen,"buttonText":_vm.$ml.get('setPinCodeButtonReg'),"titleH1":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }